import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import LayoutMixin from '@/views/dashboard/mixins/layout';

let balance_template = `
<div class="panel panel-default">
    <div class="panel-body">
        <h5 class="title upper">balance</h5>
        <div class="med-stat text-center">
            <span class="text-large">{{balance_string}}</span><span class="caption"> USD</span>
        </div>
        <div class="balance-module-footer">
            <small>This reflects your current balance accrued or owed;
                   pending charges will be rolled up into invoices at
                   the start of each month and will then be reflected here.
            </small>
        </div>
    </div>
</div>`;

var BalanceWidget = Marionette.View.extend(LayoutMixin).extend({
    className: function(){ return "account widget " + this.getWidth(); },
    ui: {
        tooltips: '[data-toggle="tooltip"]',
    },
    template: Handlebars.compile(balance_template),
    modelEvents: {
        'add': 'render'
    },
    initialize: function() {
    },
    onRender: function(){
        this.ui.tooltips.tooltip();
    },
    templateContext: function() {
        var payment = this.getOption('payment_data').attributes || {};
        var billing_parameters = this.model.billing_parameters;
        if (!this.getOption('payment_data').get('balance')) {
            payment.balance = 0;
        }

        payment.billing_parameters = billing_parameters;
        payment.balance_string = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(payment.balance);
        return payment;
    }
});

export default BalanceWidget;


